/**
 * Slider
 *
 * @selector .js-Slider
 * @enabled true
 */
import BaseModule from '../../modules/BaseModule.js';
import Swiper, { Navigation, Pagination, Autoplay, EffectCreative, Parallax, Scrollbar } from 'swiper';

class Slider extends BaseModule {
    constructor() {
        super();
    }

    init(element, options) {
        this.el = element;
        this.$el = $(this.el);

        const elOptions = this.$el.data('js-slider');

        this.swiper = new Swiper(this.el.querySelector('.js-Slider--slider'), {
            modules: [Navigation, Pagination, Autoplay, EffectCreative, Parallax, Scrollbar],
            wrapperClass: 'js-Slider--wrapper',
            slideClass: 'js-Slider--slide',
            navigation: {
                prevEl: this.el.querySelector('.js-Slider--prev'),
                nextEl: this.el.querySelector('.js-Slider--next'),
            },
            speed: 1000,
            pagination: {
                el: '.js-Slider--pagination',
                clickable: true,
            },
            scrollbar: {
                el: '.js-Slider--scrollbar',
                hide: false,
            },
            // breakpoints: {
            // 	1440: {
            // 		speed: 1000
            // 	}
            // },
            grabCursor: true,
            slidesPerView: 'auto',
            centerInsufficientSlides: true,
            slidesPerGroupAuto: true,
            ...(elOptions || {}),
            ...(options || {}),
        });

        this.el.style.setProperty('--progress', this.swiper.progress);
        this.el.style.setProperty('--transitionDuration', 0);

        this.swiper.on('slideChangeTransitionStart', () => {
            const progress = Math.min(Math.max(this.swiper.progress, 0), 1);
            this.el.style.setProperty('--transitionDuration', '1000ms');
            this.el.style.setProperty('--progress', progress);
        });

        this.swiper.on('slideChangeTransitionEnd', () => {
            this.el.style.setProperty('--transitionDuration', 0);
        });

        this.swiper.on('sliderMove', () => {
            const progress = Math.min(Math.max(this.swiper.progress, 0), 1);
            this.el.style.setProperty('--progress', progress);
        });

        return this;
    }
}

export default function createModule() {
    return new Slider();
}
